import React from 'react';
import ScheduleItemCard from './ScheduleItemCard'
import { MuiGrid } from '../../../ui/MaterialUIComponents';
function ScheduleListComponent(props) {
	return (
		<MuiGrid container direction="row"  align='left' spacing={2}>
			{props.scheduleList.map((schedule_constraint, index) => (
				<MuiGrid item xs={12} sm={6} md={4} lg={4} xl={3} style={{display: 'flex', height: 'auto' }}  id="grid" >
					<ScheduleItemCard {...props} schedule={schedule_constraint} scheduleIndex={index} />
				</MuiGrid>
			))}
		</MuiGrid>
	)

}



export default ScheduleListComponent;